import toast from "not-a-toast"

const DEFAULTS = {
  position: "top-right",
  duration: 2000,
  showProgressBar: true,
  showIcon: false
}

export function showToast(message, theme = "success", options = {}) {
  toast({ ...DEFAULTS, ...options, message, theme })
}
